import api from "./api";
import { APIS } from "../endpoints";

export const getAllSubSectionsData = async (section) => {

    const result = await api.get(`${APIS.BASE_URL}${APIS.subSections}/${section}`)

    if (result) {
        return result?.data;
    } else {
        return [];
    }
};